import { Icon, SelectionList, Text } from '@dixa/lib-shared-habla';
import { sizes } from '@dixa/lib-shared-tokens';
import * as Popover from '@radix-ui/react-popover';
import { useState } from 'react';

import { CustomAttributeOption } from 'components/conversation/conversationCustomFieldsForm/utils/useCustomAttributeSuggestions';

import styles from './customFieldSuggestionDropdownButton.module.scss';

type CustomFieldSuggestionDropdownButtonProps = {
  suggestions: CustomAttributeOption[];
  setSuggestion: (value: string[]) => void;
};

export const CustomFieldSuggestionDropdownButton = ({
  suggestions,
  setSuggestion,
}: CustomFieldSuggestionDropdownButtonProps): JSX.Element => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <Popover.Root open={isOpen} onOpenChange={setIsOpen}>
      <Popover.Trigger asChild>
        <button
          type="button"
          className={styles.trigger}
          onClick={(e) => e.stopPropagation()}
        >
          <Icon name="ai" size={16} />

          <Text.Paragraph variant="3" color="inherit">
            {suggestions.length}
          </Text.Paragraph>

          <Icon name={isOpen ? 'angle-up' : 'angle-down'} size={16} />
        </button>
      </Popover.Trigger>

      <Popover.Portal>
        <Popover.Content
          className={styles.popover}
          side="bottom"
          align="start"
          sideOffset={parseInt(sizes.spacer.values[200])}
          onClick={(e) => e.stopPropagation()}
        >
          <SelectionList<string[]>
            onChange={(event) => {
              setSuggestion(event.selectedItem.value);
            }}
          >
            <SelectionList.Section title="AI suggestions">
              {suggestions.map((suggestion) => (
                <SelectionList.Item
                  value={suggestion.value}
                  key={suggestion.label}
                >
                  {suggestion.label}
                </SelectionList.Item>
              ))}
            </SelectionList.Section>
          </SelectionList>
        </Popover.Content>
      </Popover.Portal>
    </Popover.Root>
  );
};
